(() => {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer || drawer.dataset.gyroorCheckoutLayout) return;
  drawer.dataset.gyroorCheckoutLayout = 'true';
  let initializedProtection = false;
  const refreshedPlacements = new WeakSet();
  const sync = () => {
    const footer = drawer.querySelector('.cart-drawer__footer');
    if (!footer) return;
    const checkout = footer.querySelector('button[name="checkout"]');
    const appCheckout = footer.querySelector('.xcotton-checkout-plus');
    const display = appCheckout ? 'none' : 'inline-flex';
    if (checkout && (checkout.style.getPropertyValue('display') !== display ||
        checkout.style.getPropertyPriority('display') !== 'important')) {
      checkout.style.setProperty('display', display, 'important');
    }
    if (appCheckout) {
      const label = appCheckout.querySelector('.btn-text') || appCheckout;
      if (label && label.textContent.trim() !== 'Secure checkout') label.textContent = 'Secure checkout';
    }
    const protection = drawer.querySelector('.cart-drawer__protection');
    if (protection) {
      const cards = [...footer.querySelectorAll('.xcotton_wrapper')];
      if (!protection.querySelector('.xcotton_wrapper') && cards.length) protection.append(cards[0]);
      const nativeSwitch = protection.querySelector('#xcotton-switch, .switch_btn, .xcotton-widget-switch');
      if (nativeSwitch) {
        const nativeInput = nativeSwitch.querySelector('input[type="checkbox"]');
        const isSelected = () => nativeInput ? nativeInput.checked :
          nativeSwitch.classList.contains('checked') || !!nativeSwitch.querySelector('.checked');
        let toggle = protection.querySelector('.gyroor-protection-toggle');
        if (!toggle) {
          toggle = document.createElement('label');
          toggle.className = 'gyroor-protection-toggle';
          const input = document.createElement('input');
          input.type = 'checkbox';
          input.setAttribute('aria-label', 'Include shipping protection');
          const text = document.createElement('span');
          text.textContent = 'Include shipping protection';
          toggle.append(input, text);
          protection.append(toggle);
          input.addEventListener('change', () => {
            const current = protection.querySelector('#xcotton-switch');
            if (current) current.click();
          });
        }
        toggle.querySelector('input').checked = isSelected();
        if (!initializedProtection) {
          initializedProtection = true;
          if (isSelected()) nativeSwitch.click();
        }
      }
    }
    const sdkTemplate = drawer.querySelector('template[data-gyroor-klarna-sdk]');
    const sdkSource = sdkTemplate && sdkTemplate.content.querySelector('script');
    if (sdkSource && !document.querySelector('script[src="' + sdkSource.src + '"]')) {
      const sdk = document.createElement('script');
      for (const attribute of sdkSource.attributes) sdk.setAttribute(attribute.name, attribute.value);
      document.head.append(sdk);
    }
    const placement = drawer.querySelector('.gyroor-cart-klarna klarna-placement');
    if (placement && !refreshedPlacements.has(placement)) {
      refreshedPlacements.add(placement);
      if (window.Klarna && window.Klarna.OnsiteMessaging &&
          typeof window.Klarna.OnsiteMessaging.refresh === 'function') {
        window.Klarna.OnsiteMessaging.refresh();
      }
    }
  };
  new MutationObserver(sync).observe(drawer, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class']
  });
  sync();
})();